import { observer } from 'mobx-react-lite'
import { Button, Icon, SpinnerLoader, Typography } from 'shared/ui'
import { useEmailToSmsPageStorePageContext } from 'pages/settings/pages/emailToSms/context/emailToSmsContext'
import { EmailToSmsList } from 'pages/settings/pages/emailToSms/ui/EmailToSmsList/emailToSmsList'
import styles from './styles.module.scss'

export const EmailToSmsDropdowns = observer(() => {
  const { isLoading, isGroupsUpdating, isAllInboxesMapped, addNewGroup, isPossibleToAddNewGroup } =
    useEmailToSmsPageStorePageContext()

  if (isLoading) {
    return (
      <div className={styles.wrap}>
        <SpinnerLoader ariaLabel={'emailToSmsDropdowns'} />
      </div>
    )
  }

  return (
    <div className={styles.wrap}>
      <div style={{ position: 'relative' }}>
        <EmailToSmsList />
        {isGroupsUpdating && (
          <div className={styles.gropusLoader}>
            <SpinnerLoader ariaLabel={'emailToSmsDropdowns'} />
          </div>
        )}
      </div>

      {isAllInboxesMapped && (
        <div className={styles.warning}>
          <Icon icon='alertTriangle' ariaLabel={'Alert'} />
          <Typography
            variant='body-xs-regular'
            color='var(--content-error)'
            ariaLabel={'All of your inboxes are already mapped'}
          >
            All of your inboxes are already mapped
          </Typography>
        </div>
      )}

      <Button
        icon={'add'}
        text={'Add new email'}
        size={'medium'}
        contained={'secondary'}
        onClick={addNewGroup}
        disabled={!isPossibleToAddNewGroup || isGroupsUpdating}
        style={{ marginTop: 12 }}
      />
    </div>
  )
})
